import { render, staticRenderFns } from "./facultyPartner.vue?vue&type=template&id=284c7082&scoped=true"
import script from "./facultyPartner.vue?vue&type=script&lang=js"
export * from "./facultyPartner.vue?vue&type=script&lang=js"
import style0 from "./facultyPartner.vue?vue&type=style&index=0&id=284c7082&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284c7082",
  null
  
)

export default component.exports